import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

/**
 * Always-visible signout icon-button. Meant for mobile top bars where a full
 * NavSignOut footer would be too heavy — this is a single 40x40 tap target
 * that lives permanently in the header so guests never need to open a drawer
 * to log out. Behaviour is identical to NavSignOut.
 */
export default function NavSignOutIcon({ testid = "nav-signout-icon" }) {
  const { logout } = useAuth() || {};
  const nav = useNavigate();
  const handle = async () => {
    try {
      await logout();
      toast.success("Signed out");
    } catch { /* best-effort */ }
    nav("/", { replace: true });
  };
  return (
    <button
      type="button"
      onClick={handle}
      data-testid={testid}
      aria-label="Sign out"
      className="p-2 rounded-lg text-stone-600 hover:text-red-700 hover:bg-red-50 transition"
    >
      <LogOut className="h-5 w-5" />
    </button>
  );
}
